import { Component, OnInit, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import { BankService } from '../../../shared/services/bank.service';
import { TdSearchBoxComponent, ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdDialogService, TdLoadingService, ITdDataTableSortChangeEvent, IPageChangeEvent } from '@covalent/core';
import { Bank } from '../bank';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../branch';
import { SettingsService } from '../../../shared/services/settings.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ExportService } from '../../../shared/services/export.service';
import { MdDialogRef } from '@angular/material';
import { BranchService } from '../branches/branch.service';
import { Utils } from '../../../shared/utils';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss'],
  providers: [BankService]
})
export class AccountListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Bank[];
  subscription: Subscription = new Subscription();

  allBranches$: Observable<Branch[]>;

  branchFilter: string = 'ALL';

  columns: ITdDataTableColumn[] = [
    { name: 'id', label: 'Bank ID', },
    { name: 'name', label: 'Name' },
    { name: 'type', label: 'Type' },
    { name: 'currency', label: 'Currency' },
    { name: 'branch_code', label: 'Branch' },
  ];

  filteredData: any[];
  filteredTotal: number;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  all_banks: Bank[];

  constructor(private _dataTableService: TdDataTableService,
    private _bankService: BankService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _branchService: BranchService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
    public _authService: AuthenticationService) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscription = this._bankService
      .getBanks(true)
      .subscribe((banks: Bank[]) => {
        this.all_banks = banks;

        this.data = this.all_banks.slice().filter(c => { return this._authService.getUserBranches().some(b => { return c.branch_id == b.id }) });

        this.filter();
        this._loadingService.resolve('loading');

      },
        error => {
          this._loadingService.resolve('loading');
        });

    //this.allBranches$ = this._branchService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('bank')) {
      this._searchBox.value = this._settingsService.getSearchTerm('bank');
      this._searchBox.searchClicked();
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
    ? TdDataTableSortingOrder.Descending
    : TdDataTableSortingOrder.Ascending;

    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('bank', searchTerm);
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('bank'), true, excludedColumns);
    if (this.branchFilter != 'ALL') {
      newData = newData.filter(d => { return d.branch_code == this.branchFilter });
    }
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/account-list/account-list.component.ts